module.exports = __webpack_public_path__ + "img/step3-04.4d32634d.jpg";